import { z } from 'zod';

export const AdvantageSchema = z.object({
  corporateCulture: z.string().max(4000),
  otherAdvantages: z.string().max(4000),
});
